export const TIPO_USUARIO_PESSOA_JURIDICA = 4;
export const TIPO_USUARIO_CONSULTOR = 5;
export const TIPO_REPRESENTADO_PESSOA_FISICA = 0;
export const TIPO_REPRESENTADO_PESSOA_JURIDICA = 1;

const CEP_TOTAL_DIGITS = 8;

export function isPessoaJuridica(usuario) {
  if (!usuario) return false;
  return (
    usuario.tipoUsuario === TIPO_USUARIO_PESSOA_JURIDICA ||
    usuario.tipoUsuario === "4"
  );
}

export function isConsultor(usuario) {
  if (!usuario) return false;
  return (
    usuario.tipoUsuario === TIPO_USUARIO_CONSULTOR ||
    usuario.tipoUsuario === "5"
  );
}

export function obterNomeExibicaoUsuario(usuario, fallback = "") {
  if (!usuario) return fallback;

  if (isPessoaJuridica(usuario)) {
    const representanteLegal =
      usuario.pessoaJuridica?.representanteLegal ||
      usuario.representanteLegal;
    if (representanteLegal?.trim()) {
      return representanteLegal.trim();
    }
  }

  const nomeCompleto = `${usuario.nome || ""} ${usuario.sobrenome || ""}`.trim();
  return nomeCompleto || fallback;
}

export function obterRotuloNomeSolicitante(usuario) {
  return isPessoaJuridica(usuario) ? "Representante Legal" : "Nome";
}

export function obterRazaoSocialUsuario(usuario) {
  if (!isPessoaJuridica(usuario)) return "";

  const razaoSocial =
    usuario.pessoaJuridica?.razaoSocial || usuario.razaoSocial;
  return razaoSocial?.trim() || "";
}

export function isRepresentadoPessoaJuridica(representado) {
  if (!representado) return false;
  return (
    representado.tipo === TIPO_REPRESENTADO_PESSOA_JURIDICA ||
    representado.tipo === "1"
  );
}

export function obterNomeExibicaoRepresentado(representado, fallback = "") {
  if (!representado) return fallback;

  const nomeExibicao = representado.nomeExibicao?.trim();
  if (nomeExibicao) return nomeExibicao;

  if (isRepresentadoPessoaJuridica(representado)) {
    const nomePessoaJuridica =
      representado.representanteLegal?.trim() ||
      representado.razaoSocial?.trim();
    return nomePessoaJuridica || fallback;
  }

  const nomeCompleto =
    `${representado.nome || ""} ${representado.sobrenome || ""}`.trim();
  return nomeCompleto || fallback;
}

export function obterRotuloNomeRepresentado(representado) {
  return isRepresentadoPessoaJuridica(representado)
    ? "Representante Legal"
    : "Nome";
}

export function obterRazaoSocialRepresentado(representado) {
  if (!isRepresentadoPessoaJuridica(representado)) return "";
  return representado.razaoSocial?.trim() || "";
}

export function montarRequerenteDeRepresentado(representado) {
  if (!representado) return null;

  return {
    nome: representado.nome,
    sobrenome: representado.sobrenome,
    nomeExibicao: obterNomeExibicaoRepresentado(representado),
    cpf: representado.cpf,
    telefone: representado.telefone,
    email: representado.email,
  };
}

export function montarEnderecoDoSnapshotRepresentado(snapshot) {
  if (!snapshot) {
    return { rua: "", numero: "", municipio: "", estado: "", cep: "" };
  }

  return {
    rua: snapshot.enderecoRua || "",
    numero:
      snapshot.enderecoNumero !== null && snapshot.enderecoNumero !== undefined
        ? String(snapshot.enderecoNumero)
        : "",
    municipio: snapshot.enderecoMunicipio || "",
    estado: snapshot.enderecoEstado || "",
    cep:
      snapshot.enderecoCep !== null && snapshot.enderecoCep !== undefined
        ? String(snapshot.enderecoCep).padStart(CEP_TOTAL_DIGITS, "0")
        : "",
  };
}

export function splitNomeCompleto(nomeCompleto, maxLength = 150) {
  const trimmed = (nomeCompleto || "").trim();
  if (!trimmed) {
    return { nome: "-", sobrenome: "-" };
  }

  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    const unico = parts[0].substring(0, maxLength);
    return { nome: unico, sobrenome: unico };
  }

  return {
    nome: parts[0].substring(0, maxLength),
    sobrenome: parts.slice(1).join(" ").substring(0, maxLength),
  };
}
